import { Flex, Text } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingSpinner } from '~/components/shared/LoadingSpinner'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { useAnalytics } from '~/hooks/useAnalytics'
import { AnalyticsNamespace, WebPhoneAnalyticsEvents } from '~/types/Analytics'
import { noop } from '~/utils/functions'

import { PhoneNumberInput } from './PhoneNumberInput'

interface PhoneInitializingViewProps {
  onRetryClick: () => void
}
export const PhoneInitializingView = ({
  onRetryClick,
}: PhoneInitializingViewProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation()
  const { track } = useAnalytics(AnalyticsNamespace.WEB_PHONE)
  const [showRetry, setShowRetry] = useState(false)
  useEffect(() => {
    if (!showRetry) {
      const timeout = setTimeout(() => {
        setShowRetry(true)
      }, 5 * 1000)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [showRetry])

  const handleRetryClick = () => {
    onRetryClick()
    setShowRetry(false)
    track(WebPhoneAnalyticsEvents.RestartSipClientInitClick)
  }

  return (
    <Flex
      direction="column"
      alignSelf="center"
      align="center"
      w={{ base: '23.75rem', lg: '25rem', xl: '30rem' }}
      h="85%"
      pt={{ base: '3.75rem', lg: '5rem' }}
    >
      <PhoneNumberInput
        inputRef={inputRef}
        phonenumber=""
        onPhonenumberChange={noop}
        onStartCall={noop}
        disabled
      />
      {showRetry ? (
        <Flex direction="column" align="center" py="6.25rem" gap="1.25rem">
          <Text textAlign="center" textStyle="Body1">
            {t('webPhone.callError.connectionFailed')}
          </Text>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleRetryClick}
          >
            {t('webPhone.callError.retry')}
          </MangoButton>
        </Flex>
      ) : (
        <Flex direction="column" align="center" py="6.25rem" gap="1.25rem">
          <LoadingSpinner />
          <Text textAlign="center" textStyle="Body1" color="fg.muted">
            {t('webPhone.callError.connecting')}
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
